<template>
  <v-card
    class="mx-auto pa-2 overflow-visible"
    outlined
  >
    <v-list-item>
      <v-list-item-content class="overflow-visible">
        <v-list-item-title class="headline mb-2">
          Danh sách sản phẩm bán được trong kỳ
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <div class="px-5">
      <v-row>
        <v-col cols="12" md="6" class="py-0">
          <v-autocomplete
            v-model="groupIds"
            :items="productList"
            item-text="name"
            item-value="id"
            label="Tìm kiếm theo nhóm sản phẩm"
            placeholder="Nhóm sản phẩm"
            color="primary"
            clearable
            multiple=""
          />
        </v-col>
        <v-col cols="12" class="text-center">
          <v-btn
            class="primary mx-0"
            @click="search"
          >
            <v-icon>mdi-magnify</v-icon>Tìm kiếm
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <productGroupSoldTable
      :data="data"
      :filter-form="filterForm"
    />
    
  </v-card>
</template>

<script>

import productGroupSoldTable from './ProductGroupSoldTable'
import { formatDate } from '@/helpers/utils'

import RepositoryFactory from "@/repositories/RepositoryFactory";
const ReportRepository = RepositoryFactory.get('report');
const ProductGroupRepository = RepositoryFactory.get('product_group');
import * as moment from 'moment'

  export default {
    components: {
      productGroupSoldTable
    },
    props: {
      filterForm: {
        default: () => ({})
      },
    },
    data () {
      return {
        productList: [],
        data: [],
        groupIds: [],
      }
    },
    created() {
      Bus.$on('sold-product-report-thpt', () => {
        this.search()
      })
    },
    beforeDestroy() {
      Bus.$off('sold-product-report-thpt')
    },
    methods: {
      search() {
        this.fetchProductList()
        this.getData()
      },
      async fetchProductList() {
        const params = {
         limit: 100,
        };
        const response = await ProductGroupRepository.list(params)
        if (response.success) {
          this.productList = _.get(response, 'data', [])
        }
      },
      async getData() {
        const loader = this.$loading.show()
        const params = {
          startDateTime: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD 00:00:00'),
          endDateTime: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD 23:59:59'),
          groupIds: this.groupIds,
          schoolLevelIds: [2]
        };
        const response = await ReportRepository.productGroupSold(params)
        loader.hide()
        if (response.success) {
          this.data = _.get(response, 'data', [])
        }
      }
    },
  }
</script>

<style lang="scss">
  .ct-major-second {
    svg {
      position: relative;
    }
    &:before {
      padding-bottom: 0;
    }
  }
</style>